import { useState, useRef, useEffect } from "react";
import { db } from "../../Utils/Functions/Dexie-Setup";
import { useLiveQuery } from "dexie-react-hooks";
import Modal from "../elements/Modal/Modal";
import SignatureCanvas from "react-signature-canvas";
import SRFButton from "./SRFButton/SRFButton";
import { iframeSrc } from "../..";
import { pFetch } from "../../Utils/Functions/helpers";

const labels = {
  getSignature: "Get Signature",
  clearSignature: "Clear Signature",
  saveSignature: "Save Signature",
  cancel: "Cancel",
  clear: "Clear",
  dateSigned: "Date Signed",
}


function SignatureInput({ tableName, primaryKey, fieldName, dateTimeFieldName, disabled, buttonLabels, label = "Signature", ...rest }) {
  const finalLabels = { ...labels, ...buttonLabels }
  const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const canvasRef = useRef(null);
  const onCloseModal = () => {
    setIsModalOpen(false);
  }

  const onSignatureSave = () => {
    const signaturePad = canvasRef.current;
    const str = signaturePad.toDataURL();
    console.log(str);
    const data = str.replace(/^data:(.*,)?/, '');
    console.log(data);
    const fileName = `${Date.now()}.png`;
    db[tableName].update(primaryKey, {
      [fieldName]: { fileName, data },
      ...(dateTimeFieldName ? { [dateTimeFieldName]: new Date().toISOString() } : {})
    })
    setIsModalOpen(false)
  }

  const onSignatureClear = () => {
    db[tableName].update(primaryKey, {
      [fieldName]: undefined,
      ...(dateTimeFieldName ? { [dateTimeFieldName]: "" } : {})
    })
  }

  useEffect(() => {
    const field = record?.[fieldName];
    if (field) {
      if (field?.url) {
        const splitURL = field?.url?.split("/");
        const url = `${iframeSrc}up/${splitURL[2]}/a/r${splitURL[3]}/e${splitURL[4]}`;

        pFetch(url, {
          method: "GET",
          credentials: "include"
        }).then(res => res.blob()).then(blob => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })).then(dataURL => setImgSrc(dataURL));
      } else if (field?.data) {
        setImgSrc(`data:image/png;base64,${record[fieldName].data}`);
      }
    }
  }, [record, setImgSrc])

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [isModalOpen]);

  return (
    <>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <div className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
        {record && (record?.[fieldName]?.url || record?.[fieldName]?.data) ? (<>
          <img alt="Signature" src={imgSrc} />
          {dateTimeFieldName ? <span>{finalLabels.dateSigned}: {new Date(record[dateTimeFieldName]).toLocaleString()}</span> : null}
        </>) : null}
        {!disabled ?
          <div className="w-full flex">
            <SRFButton
              color="var(--blue)"
              onClick={() => setIsModalOpen(true)}
              {...rest}
            >{finalLabels.getSignature}</SRFButton>
            {record?.[fieldName] ?
              <SRFButton
                color="var(--red)"
                onClick={onSignatureClear}
                {...rest}
                width={"25%"}
              >{finalLabels.clear}</SRFButton>
              : null}
          </div>
          : null
        }


      </div>
      {isModalOpen && <Modal closeText={finalLabels.cancel} isOpen={isModalOpen} onClose={onCloseModal}>

        <div className="w-[95vw] h-[90vh] flex flex-col items-center w">
          <SignatureCanvas ref={canvasRef} throttle={12} minDistance={2} minWidth={1.5} maxWidth={2.5} canvasProps={{
            className: "w-11/12 h-2/3 border-b-2 border-black"
          }} />
          <div className="flex gap-2">

            <SRFButton onClick={() => canvasRef.current.clear()}>{finalLabels.clearSignature}</SRFButton>
            <SRFButton onClick={onSignatureSave}>{finalLabels.saveSignature}</SRFButton>
          </div>
        </div>

      </Modal>
      }
    </>
  )
}

export default SignatureInput;
